export function useChatAPI(getApiEndpoint) {
    const sendMessage = async (message, conversationId, promptOverrides, chatHistory, abortSignal) => {
        const apiEndpoint = getApiEndpoint();
        const requestBody = {
            message,
            conversationId,
            context: {},
            ...(promptOverrides && { promptOverrides }),
            chatHistory,
        };
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
                signal: abortSignal,
            });
            if (!response.ok) {
                if (response.status === 403) {
                    throw new Error('Prompt overrides not allowed in production');
                }
                if (response.status === 429) {
                    throw new Error('Rate limit exceeded. Please try again in a moment.');
                }
                if (response.status === 500) {
                    throw new Error('Server error. Please try again.');
                }
                throw new Error(`API Error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        }
        catch (error) {
            if (error.name === 'AbortError') {
                throw new Error('Request was cancelled');
            }
            if (error.name === 'TypeError' && error.message.includes('fetch')) {
                throw new Error(error.message);
            }
            throw error;
        }
    };
    return { sendMessage };
}
